const configured = (process.env.REACT_APP_BACKEND_URL || '').replace(/\/$/, '');
const local = /^https?:\/\/(localhost|127\.0\.0\.1|\[::1\])(?=[:/]|$)/i.test(configured);
export const BACKEND_URL = process.env.NODE_ENV === 'production' && local ? '' : configured;
export const API = `${BACKEND_URL}/api`;
